export default __webpack_public_path__ + "static/media/330_private01-en-mobile.320d5d9f.png";